import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import SSOTransition from '../components/SSOTransition';
import { API_URL } from '../apiBase';

const SSOPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { loginWithSSO } = useAuth();
  const [showTransition, setShowTransition] = useState(false);
  const [userName, setUserName] = useState('');
  const [error, setError] = useState(null);
  const hasValidated = useRef(false);

  useEffect(() => {
    if (hasValidated.current) return;
    hasValidated.current = true;

    const validateSSO = async () => {
      const token = searchParams.get('token');
      const username =
        searchParams.get('user') || searchParams.get('username');

      if (!token || !username) {
        setError('Paramètres SSO manquants (token et user ou username)');
        return;
      }

      try {
        // Valider le token SSO auprès du backend
        const response = await axios.post(`${API_URL}/api/sso/validate`, {
          token,
          username
        });

        if (response.data.access_token && response.data.user) {
          const user = response.data.user;
          setUserName(`${user.prenom} ${user.nom}`);
          
          // Connexion réussie via SSO
          await loginWithSSO(response.data.access_token, user);
          
          // Afficher la transition
          setShowTransition(true);
        } else {
          setError('Réponse invalide du serveur');
        }
      } catch (err) {
        if (err.response?.data?.detail) {
          setError(err.response.data.detail);
        } else {
          setError('Erreur de connexion SSO');
        }
      }
    };

    validateSSO();
  }, [searchParams, loginWithSSO]);

  // Afficher la transition SSO
  if (showTransition) {
    return (
      <SSOTransition 
        onComplete={() => navigate('/dashboard', { replace: true })}
        userName={userName}
      />
    );
  }

  // Afficher l'erreur si présente
  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #0a0f1a 0%, #111827 50%, #0a0f1a 100%)' }}>
        <div className="bg-gray-900/80 border border-gray-700/50 rounded-2xl p-8 max-w-md w-full mx-4 backdrop-blur-xl">
          <div className="w-16 h-16 bg-red-500/10 border border-red-500/30 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
          <h2 className="text-xl font-semibold text-white text-center mb-2">
            Erreur de connexion
          </h2>
          <p className="text-red-400 text-sm text-center mb-6">
            {error}
          </p>
          <button
            onClick={() => navigate('/login')}
            className="w-full px-6 py-3 bg-gray-700/50 hover:bg-gray-700 text-white font-medium rounded-xl transition-all duration-200"
          >
            Retour
          </button>
        </div>
      </div>
    );
  }

  // État de chargement initial (validation du token)
  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #0a0f1a 0%, #111827 50%, #0a0f1a 100%)' }}>
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-cyan-400 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-gray-400">Validation en cours...</p>
      </div>
    </div>
  );
};

export default SSOPage;
